'use client';

import Link from 'next/link';
import MLink from '@mui/material/Link';

type Props = {
  href?: string;
  as?: string;
  children?: React.ReactNode;
  [key: string]: unknown;
};

const MaterialLink = ({ href, as, children, ...props }: Props) => (
  <MLink component={Link} href={as || href} {...props}>
    {children}
  </MLink>
);

export default MaterialLink;
